import { all, put, retry, call } from 'redux-saga/effects';
import { reject, resolve } from '../api';
import * as types from '../constants';
import { NOTIFICATION } from '../constants';
import { authClient } from '../api/Client';
import {
  errorNotification,
  showNotification,
  successNotification,
  simpleErrorNotification,
} from '../../shared-components/Notifications';

export function* loadSources(
  state,
  scope,
  page,
  source_name,
  ioc_type,
  data_source,
  vendor,
  sort,
) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Source?.loadSources,
      state,
      scope,
      page,
      source_name,
      ioc_type,
      data_source,
      vendor,
      sort,
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_SOURCES),
        payload: res?.data(),
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Request sent',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_SOURCES),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Loading sources was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_SOURCES),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_SOURCES),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_SOURCES)),
  //     }),
  //   ]);
  // }
}

export function* loadSource({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.Source?.loadSource, {
      uuid: uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_SOURCE),
        payload: res?.data(),
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Request sent',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_SOURCE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Loading source was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_SOURCE),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_SOURCE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_SOURCE)),
  //     }),
  //   ]);
  // }
}

export function* loadSourcesIocCountsAndIsActive(
  state,
  scope,
  page,
  source_name,
  ioc_type,
  data_source,
  vendor,
  sort,
) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Source?.loadSourcesIocCountsAndIsActive,
      state,
      scope,
      page,
      source_name,
      ioc_type,
      data_source,
      vendor,
      sort,
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_SOURCES_IOC_COUNTS_AND_IS_ACTIVE),
        payload: res?.data(),
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Request sent',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_SOURCES_IOC_COUNTS_AND_IS_ACTIVE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Loading Feed information was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_SOURCES_IOC_COUNTS_AND_IS_ACTIVE),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_SOURCES_IOC_COUNTS_AND_IS_ACTIVE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_SOURCES_IOC_COUNTS_AND_IS_ACTIVE),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadSourcesIocCounts(
  state,
  scope,
  page,
  source_name,
  ioc_type,
  data_source,
  vendor,
  sort,
) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Source?.loadSourcesIocCounts,
      state,
      scope,
      page,
      source_name,
      ioc_type,
      data_source,
      vendor,
      sort,
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_SOURCES_IOC_COUNTS),
        payload: res?.data(),
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Request sent',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_SOURCES_IOC_COUNTS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Loading IOC count was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_SOURCES_IOC_COUNTS),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_SOURCES_IOC_COUNTS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.LOAD_SOURCES_IOC_COUNTS),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* createEmptySource({ data }) {
  try {
    const res = yield call(authClient?.Source?.createEmptySource, {
      body: data,
    });
    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CREATE_EMPTY_SOURCE),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source has been created successfully.',
        }),
      );
      yield loadSources({
        state:
          data?.state?.toString()?.toLowerCase() === 'collection'
            ? 'collection'
            : 'feed',
      });
    } else {
      yield all([
        put({
          type: reject(types?.CREATE_EMPTY_SOURCE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source creation was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CREATE_EMPTY_SOURCE),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source has been created successfully.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CREATE_EMPTY_SOURCE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CREATE_EMPTY_SOURCE),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* createURLSource({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Source?.createURLSource, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CREATE_URL_SOURCE),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source has been created successfully.',
        }),
      );
      yield loadSources({
        state:
          data?.state?.toString()?.toLowerCase() === 'collection'
            ? 'collection'
            : 'feed',
      });
    } else {
      yield all([
        put({
          type: reject(types?.CREATE_URL_SOURCE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source creation was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CREATE_URL_SOURCE),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source with observable(s) created',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CREATE_URL_SOURCE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CREATE_URL_SOURCE),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* createFileSource({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Source?.createFileSource, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CREATE_FILE_SOURCE),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source has been created successfully.',
        }),
      );
      yield loadSources({
        state:
          data?.state?.toString()?.toLowerCase() === 'collection'
            ? 'collection'
            : 'feed',
      });
    } else {
      yield all([
        put({
          type: reject(types?.CREATE_FILE_SOURCE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source creation was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CREATE_FILE_SOURCE),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source with observable(s) created',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CREATE_FILE_SOURCE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CREATE_FILE_SOURCE),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteSource({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.Source?.deleteSource, {
      uuid: uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_SOURCE),
        uuid: uuid,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source has been deleted',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_SOURCE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source deletion was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_SOURCE),
  //     uuid: uuid,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source has been deleted',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_SOURCE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.DELETE_SOURCE)),
  //     }),
  //   ]);
  // }
}

export function* changeSourceScope({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Source?.changeSourceScope, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CHANGE_SOURCE_SCOPE),
        payload: res?.data(),
      });
      const message =
        data?.scope === 'ORGANISATION'
          ? 'Source has been shared with your organization'
          : 'Source has been updated';

      showNotification(
        successNotification({
          statusCode: 200,
          message: message,
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.CHANGE_SOURCE_SCOPE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source deletion was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CHANGE_SOURCE_SCOPE),
  //     payload: res?.data(),
  //   });

  //   const message =
  //     data?.scope === 'ORGANISATION'
  //       ? 'Source has been shared with your organization'
  //       : 'Source has been updated';

  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: message,
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CHANGE_SOURCE_SCOPE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CHANGE_SOURCE_SCOPE),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* activateSource({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Source?.activateSource, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.ACTIVATE_SOURCE),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source has been updated',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.ACTIVATE_SOURCE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.ACTIVATE_SOURCE),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source has been updated.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.ACTIVATE_SOURCE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.ACTIVATE_SOURCE)),
  //     }),
  //   ]);
  // }
}

export function* updateSource({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Source?.updateSource, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_SOURCE),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source has been updated',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_SOURCE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_SOURCE),
  //     payload: res?.data(),
  //   });

  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source has been updated',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_SOURCE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.UPDATE_SOURCE)),
  //     }),
  //   ]);
  // }
}

export function* updateFileSource({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Source?.updateFileSource, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_FILE_SOURCE),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Source has been updated',
          duration: 4,
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_FILE_SOURCE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Source update was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_FILE_SOURCE),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Source has been updated',
  //       duration: 4,
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_FILE_SOURCE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_FILE_SOURCE),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* addIOCJson({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Source?.addIOCJson, {
      body: data,
      uuid: data?.feed_uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.ADD_IOC_JSON),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'The observable has been added to the source.',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.ADD_IOC_JSON),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Adding the IOC was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.ADD_IOC_JSON),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'The observable has been added to the source.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.ADD_IOC_JSON),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.ADD_IOC_JSON)),
  //     }),
  //   ]);
  // }
}

export function* publishSource({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Source?.publishSource, {
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.PUBLISH_SOURCE),
        uuid: data?.uuid,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Collection has been published',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.PUBLISH_SOURCE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Collection publish was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.PUBLISH_SOURCE),
  //     uuid: data?.uuid,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Collection has been published',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.PUBLISH_SOURCE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.PUBLISH_SOURCE)),
  //     }),
  //   ]);
  // }
}
